<template>
    <div class="home">
        <!-- //192.168.33.14:5500 -->
        <!-- 47.99.177.252:8182 -->
        <iframe name="GIS" frameborder="0" width="100%" height="100%" ref="iframeDom"
            src="http://47.99.177.252:8182/Apps/Sandcastle/gallery/web.html">
        </iframe>
        <!-- <div class="parkLogo"><img src="../assets/img/logo.png"></div> -->
        <!-- <MenuButton :content="'站点概况'" @click="$router.push({path: '/site/3'})"></MenuButton> -->
        <MenuButton :content="'园区概况'" @click="menu === 1 ? menu = -1 : menu = 1" :selected="menu === 1" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/park.png'),
                        require('../assets/img/park_c.png'),
                    ]"  v-on:onSelected="test"
                    v-on:onUnselected="clearview" class="OverviewButton"></MenuButton>
        <!-- <Chart :data="[20,50]"></Chart> -->
        <HistogramChart v-show="flag" :flag="flag"></HistogramChart>
        <SankeyChart v-show="flag" :flag="flag"></SankeyChart>
        <div class="byin">Powered by 魅客科技有限公司</div>
    </div>
</template>

<script>
    import MenuButton from "../components/MenuButton";
    // import Chart from "../components/Chart";
    import HistogramChart from "../components/HistogramChart";
    import SankeyChart from "../components/SankeyChart";
    export default {
        name: "OverView",
        components: {
            MenuButton,
            // Chart,
            HistogramChart,
            SankeyChart
        },
        data() {
            return {
                // 底部导航菜单
                menu: 0,
                iframeWin: {},
                flag: false
            }
        },
        mounted() {
            this.iframeWin = this.$refs.iframeDom.contentWindow;
            window.addEventListener("message", this.handleMessage);
        },
        methods: {
            sendMessage(value) {
                this.iframeWin.postMessage({
                    cmd: value,
                }, "*");
            },
            test(){
                this.flag = true
                this.sendMessage('parkOverview')
            },
            clearview(){
                this.flag = false
                this.sendMessage('clearParkOverview')
            }
        }
    };
</script>


<style lang="less" scoped>
.byin{
           position: fixed;
    bottom: 10px;
    right: 12px;
    font-size: 12px;
    color: #c7c5c5;
}
.parkLogo{
   position: fixed;
    top: 20px;
    z-index: 10;
    left: 50px;
    img{width: 172px;opacity: 0.7;}
}

    .home {
        margin: 0;
        padding: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }

    iframe{
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
    }
    .OverviewButton{
        right: 16vw;
        left: inherit;
    }
</style>